import React from 'react'

export default function FAQs({faqs}){
    return faqs.map(faq => (
        <div style={{paddingBottom: 10}}>
            <h3 class="has-text-weight-bold is-size-5">{faq.question}</h3>
            <p>{faq.answer}</p>
        </div>
    ))
}